import { useDispatch, useSelector } from 'react-redux';

import OtpInput from 'react-otp-input';
import Select from 'react-select';
import { Button, Col, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';

import { useEffect, useState } from 'react';
import {
  COMPLETE_BOOKING_GOLF,
  COMPLETE_BOOKING_GOLF_EMPTY,
  GET_REASON_BY_ACTIONS,
  GET_REASON_BY_ACTIONS_EMPTY,
  RESEND_OTP,
  RESEND_OTP_EMPTY,
  VALIDATE_OTP,
  VALIDATE_OTP_EMPTY,
} from '../../../../../../../store/actions';
import useCountdownTimer from '../../../../../Client/Landmark/Components/Generatevoucher/Components/Common/CountDownTimerHook';

export default function MarkAsComplete({ onClose, currentSelectedBooking, isMultiSelectable }) {
  const dispatch = useDispatch();

  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [isShowMarkAsComplete, setIsShowMarksAsComplete] = useState(false);
  const [isShowVerifyOTP, setIsShowVerifyOTP] = useState(false);

  /* ---------------------------- REDUX STATES ---------------------------- */
  const { completeBooking, completeBookingLoading, markAsCompleteReasons, markAsCompleteReasonsLoading } = useSelector(state => ({
    completeBooking: state?.CompleteBookingGolf?.data,
    completeBookingLoading: state?.CompleteBookingGolf?.loading,

    markAsCompleteReasons: state?.GetReasonByActions?.data,
    markAsCompleteReasonsLoading: state?.GetReasonByActions?.loading,
  }));

  useEffect(() => {
    setIsShowMarksAsComplete(true);
  }, []);

  useEffect(() => {
    dispatch({
      type: GET_REASON_BY_ACTIONS,
      payload: {
        urlParams: {
          booking_type: currentSelectedBooking?.bookingType || '',
          booking_status: currentSelectedBooking?.bookingStatus,
          action: 'complete_booking',
          is_active: true,
        },
      },
    });
  }, [currentSelectedBooking]);

  useEffect(() => {
    if (completeBooking !== null) {
      setIsShowMarksAsComplete(false);
      setIsShowVerifyOTP(true);
    }
  }, [completeBooking]);

  /* ---------------------------- COMPLETE BOOKING HANDLER ---------------------------- */
  const completeBookingHandler = () => {
    dispatch({
      type: COMPLETE_BOOKING_GOLF,
      payload: {
        body: {
          booking_ids: isMultiSelectable ? currentSelectedBooking?.map(booking => booking?.id) : [`${currentSelectedBooking?.id}`],
        },
      },
    });
  };

  console.log('currentSelectedBookingcurrentSelectedBooking', currentSelectedBooking);
  return (
    <>
      {isShowVerifyOTP && (
        <VerifyOTP
          currentSelectedBooking={currentSelectedBooking}
          onClose={() => {
            setIsShowVerifyOTP(false);
            setIsShowMarksAsComplete(false);
            dispatch({
              type: COMPLETE_BOOKING_GOLF_EMPTY,
            });
            onClose();
          }}
          isMultiSelectable={isMultiSelectable ?? false}
          reasonsList={markAsCompleteReasons?.reasons ?? []}
          completeBookingRes={completeBooking}
        />
      )}

      <Modal isOpen={isShowMarkAsComplete} centered>
        <ModalHeader toggle={onClose}>
          {/* {isMultiSelectable && Array.isArray(currentSelectedBooking) && currentSelectedBooking?.length > 1 ? (
            <h4>Mark {currentSelectedBooking?.length ?? 0} Bookings as Complete</h4>
          ) : (
            <h4>Mark Booking as Complete</h4>
          )}

          {isMultiSelectable && Array.isArray(currentSelectedBooking) && currentSelectedBooking?.length === 1 && (
            <p className="modal-subheading">Booking ID : {currentSelectedBooking?.[0]?.bookingId ?? ''}</p>
          )} */}

          <h4 className="assign-vendor-title">
            Mark Booking as Complete <div className="vendor-booking-id mt-1"> Booking ID: {currentSelectedBooking?.bookingId}</div>
          </h4>
        </ModalHeader>

        <ModalBody>
          <Row>
            <Col md={12} className="mt-3 mb-4 text-center">
              {!completeBookingLoading && (
                <Button color="primary" style={{ fontSize: '14px', width: '160px' }} onClick={completeBookingHandler}>
                  Send OTP
                </Button>
              )}

              {completeBookingLoading && (
                <Button color="primary" style={{ fontSize: '14px', width: '160px' }}>
                  <Spinner className="btn-replacer-spinner" />
                </Button>
              )}
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
}

const VerifyOTP = ({ onClose, currentSelectedBooking, isMultiSelectable, reasonsList, completeBookingRes }) => {
  const dispatch = useDispatch();

  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [selectedReason, setSelectedReason] = useState(null);
  const [isShowValidationError, setIsShowValiditionError] = useState(false);

  const [otp, setOtp] = useState('');
  const [timeLeft, startTimer] = useCountdownTimer(60);

  /* ---------------------------- REDUX STATES ---------------------------- */
  const { resendOTP, resendOTPLoading, validateOTPResponse, validateOTPResponseLoading } = useSelector(state => ({
    resendOTP: state?.ResendOTP?.data,
    resendOTPLoading: state?.ResendOTP?.loading,

    validateOTPResponse: state?.ValidateOTP?.data,
    validateOTPResponseLoading: state?.ValidateOTP?.loading,
  }));

  const handleChange = value => {
    if (/^\d{0,4}$/.test(value)) {
      setOtp(value);
    }
  };

  useEffect(() => {
    startTimer(60);
  }, []);

  useEffect(() => {
    if (resendOTP) {
      startTimer(60);

      dispatch({
        type: RESEND_OTP_EMPTY,
      });
    }
  }, [resendOTP]);

  useEffect(() => {
    if (validateOTPResponse !== null) {
      dispatch({
        type: RESEND_OTP_EMPTY,
      });

      dispatch({
        type: VALIDATE_OTP_EMPTY,
      });

      dispatch({
        type: GET_REASON_BY_ACTIONS_EMPTY,
      });

      dispatch({
        type: COMPLETE_BOOKING_GOLF_EMPTY,
      });

      onClose();
    }
  }, [validateOTPResponse]);

  const resendOTPHandler = () => {
    dispatch({
      type: RESEND_OTP,
      payload: {
        body: {
          data_id: `${completeBookingRes?.dataId}`,
        },
      },
    });
  };

  const verificationHandler = () => {
    dispatch({
      type: VALIDATE_OTP,
      payload: {
        body: {
          ...(otp?.length === 4 && { otp: `${otp}` }),
          reason_id: `${selectedReason?.value ?? null}`,
          data_id: `${completeBookingRes?.dataId}`,
        },
      },
    });
  };

  return (
    <>
      <Modal isOpen={true} centered>
        <ModalHeader toggle={onClose}>
          <h4>Verify Customer's details</h4>
        </ModalHeader>

        <ModalBody>
          <p className="send-otp-lbl m-0" style={{ color: '#001849' }}>
            Enter the OTP sent on your Mobile Number
            <span className="optional-lbl">(Optional)</span>
          </p>
          <p className="send-otp-lbl" style={{ color: '#001849' }}>
            Customer Name: <span className="customer-name">{currentSelectedBooking?.name}</span>
          </p>
          <div>
            <OtpInput
              value={otp}
              onChange={handleChange}
              numInputs={4}
              renderInput={(props, index) => (
                <input
                  {...props}
                  onKeyPress={e => {
                    if (!/^\d$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              )}
              inputStyle={{
                padding: '5px',
                margin: '10px 10px',
                alignItems: 'center',
                textAlign: 'center',
                height: '50px',
                width: '90px',
                color: 'black',
                borderRadius: '5px',
                backgroundColor: 'transparent',
                border: '1px solid #E1E1E1',
                outline: 'none',
                background: '#FFFFFF',
                gap: '10px',
                fontSize: '16px',
              }}
            />
          </div>

          <div className="timer-container">
            <div className="remaining-timer-container">
              {timeLeft > 0 ? (
                <span className="time-remaining-lbl">
                  Time Remaining:
                  <span className="remaining-timer">{` ${Math.floor(timeLeft / 60)}:${
                    timeLeft % 60 < 10 ? `0${timeLeft % 60}` : timeLeft % 60
                  }`}</span>
                </span>
              ) : (
                <span> </span>
              )}

              <div className={`resend-link ${timeLeft > 0 ? 'disabled' : ''}`} onClick={timeLeft <= 0 && resendOTPHandler}>
                Resend Otp
              </div>
            </div>
          </div>

          {/* <div class="verification-separator">
            <span>OR</span>
          </div> */}

          <Col className="mt-3">
            <Label htmlFor="" className="form-label">
              Remarks
            </Label>
            <Select
              id="completion-remarks"
              name="completion-remarks"
              placeholder="Select remarks"
              value={selectedReason}
              options={reasonsList?.map((remark, index) => ({
                label: `${remark?.reason}`,
                value: `${remark?.id}`,
              }))}
              onChange={data => {
                setIsShowValiditionError(false);
                setSelectedReason(data);
              }}
            />
          </Col>

          {isShowValidationError && <div className="show-error">Kindly select reason</div>}

          <Col md={12} className="mt-4 mb-4 text-center">
            {!validateOTPResponseLoading && (
              <Button
                color="primary"
                style={{ fontSize: '14px', width: '160px' }}
                onClick={() => {
                  if (selectedReason === null) {
                    setIsShowValiditionError(true);
                  } else {
                    verificationHandler();
                  }
                }}
              >
                Verify
              </Button>
            )}

            {validateOTPResponseLoading && (
              <Button color="primary" style={{ fontSize: '14px', width: '160px' }}>
                <Spinner className="btn-replacer-spinner" />
              </Button>
            )}
          </Col>
        </ModalBody>
      </Modal>
    </>
  );
};
